<template>
  <div id="childPersonPlan" v-loading="loading" :element-loading-text="loadingTxt"
    element-loading-background="rgba(255,255,255,0.7)">
    <div class="left">
      <div style="" class="title">
        {{ $titles.child }}列表
      </div>
      <div class="leftNav">
        <el-tree ref="tree" :data="treeData" :props="defaultProps" :expand-on-click-node="false" highlight-current
          node-key="childId" default-expand-all @node-click="clickNodeTree">
          <template #default="{ data }">
            <div style="display:flex;align-items:center;color:font-weight:400">
              <img :src="findImagePath(data)" alt="" style="margin-right:7.5px" />
              <span :title="data.childName" class="textAll">{{ data.childName }}</span>
            </div>
          </template>
        </el-tree>
      </div>
    </div>
    <div class="centerLine"></div>
    <div class="right">
      <div class="rightTop">
        <div class="operations">
          <el-tooltip :disabled="currentDataShow" class="item" effect="light" :content="`选择${$titles.child}后策划人员`" placement="bottom"
            popper-class="eltooltipcehua">
            <span>
              <el-button v-if="addChildPersonPlan" :disabled="!currentDataShow" size="small" class="btnBgColor"
                type="primary" @click="addPerson">
                策划人员
              </el-button>
            </span>
          </el-tooltip>
          <el-button v-if="deleChildPersonPlan" size="small" plain class="btnBgColor" type="danger" @click="delPerson">
            删除
          </el-button>
          <el-button type="primary" size="small" plain class="btnBgColor" @click="back">返回</el-button>
        </div>

        <div class="searchAndWarning">
          <div class="search">
            <el-input v-model.trim="searchValue" type="text" :placeholder="`请输入姓名、手机号、专业、${$titles.child}`"
              :title="`请输入姓名、手机号、专业、${$titles.child}`"
              prefix-icon="el-icon-search" clearable maxlength="20" show-word-limit size="small"
              @keyup.enter.native="search">
            </el-input>
            <el-button type="primary" style="margin-left:5px" size="small" @click="search">搜索</el-button>
          </div>
        </div>
      </div>
      <div class="rightBottom">
        <el-table ref="multipleTable" v-loading="tableLoading" :data="list" element-loading-text="数据加载中..."
          tooltip-effect="dark" empty-text="" height="100%" border @selection-change="selectChange">
          <template slot="empty">
            <img :src="zanwu" alt="">
            <p style="font-size:16px;color:#000;">暂无数据</p>
          </template>
          <el-table-column :selectable="checkboxInit" type="selection" width="55" align="center"
            @selection-change="selectChange">
          </el-table-column>
          <el-table-column show-overflow-tooltip align="center" label="姓名" prop="userName"> </el-table-column>
          <el-table-column show-overflow-tooltip align="center" label="手机号" prop="phone"> </el-table-column>
          <el-table-column show-overflow-tooltip prop="specName" align="center" label="专业"> </el-table-column>
          <el-table-column show-overflow-tooltip prop="childName" align="center" :label="`${$titles.child}:`"> </el-table-column>
          <el-table-column show-overflow-tooltip prop="roleName" align="center" label="角色"> </el-table-column>
        </el-table>
      </div>
    </div>
    <el-dialog v-dialogDrag :visible.sync="personChooseShow" :close-on-click-modal="false"
      :close-on-press-escape="false" class="tabTransfer" title="策划人员" custom-class="tabTransfer-dialog" width="707px"
      @close="personChooseShow = false">
      <div>
        <div class="personBox">
          <div class="distribution">
            <div class="people">
              <div class="search">
                <el-input v-model="filterPeople" placeholder="请输入姓名/专业" class="input-with-select" size="small"
                  prefix-icon="el-icon-search">
                </el-input>
              </div>
              <div class="tree">
                <el-tree ref="personTree" class="filter-tree" :data="personAll" :props="defaultPropsPerson"
                  default-expand-all highlight-current node-key="userIdRoleId" :expand-on-click-node="false"
                  :filter-node-method="filterNode" @node-click="clickNodeTreePeople">
                </el-tree>
              </div>
            </div>
            <div class="selectPeople">
              <div class="box">
                <span>已选员工(</span>
                <span style="color:#4777E7;">{{ selectList.length }}</span>
                <span>人)</span>
              </div>
              <ul>
                <li v-for="(item, index) in selectList" :key="index">
                  <span>{{ item.selecName }}</span>
                  <div @click="handleDelSelect(index)">x</div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="close">取消</el-button>
        <el-button :disabled="!selectList[0]" type="primary" size="small" @click.stop="confirmAddPerson">确定</el-button>
      </span>
      <div v-if="addLoading" v-loading="addLoading" :element-loading-text="addLoadingTxt"
        style="width:100%;height:100%;position:absolute;left:0;top: 0;" element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(255,255,255, 0.5)"></div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import childPersonPlan from "@/CommonDP/service/childPersonPlan-service";
import { checkPermission } from "@/CommonDP/utils/routeAuth";
import requestprj from "@/CommonDP/service/XtDesign-service";
import ElTree from "@/CommonDP/lib/tree/src/tree.vue";
import { storage } from "@/CommonDP/utils";
export default {
  name: "ChildPersonPlan",
  components: {
    ElTree
  },
  data() {
    return {
      loading: true,
      tableLoading: false,
      addLoading: false,
      addLoadingTxt: "数据加载中...",
      loadingTxt: "数据加载中...",
      searchValue: "",
      treeData: [],
      list: [],
      defaultProps: { children: "childList", label: "childName" },
      selectArr: [],
      pageNo: 1,
      pageSize: 9999,
      currentNode: {},
      currentData: {},
      personAll: [],
      confirmPerson: [],
      filterMethod(query, item) {
        return item.name.indexOf(query) > -1;
      },
      propsObj: {
        key: "userID"
      },
      personChooseShow: false,
      zanwu: require("@/CommonDP/assets/暂无数据.png"),
      currentDataShow: false,
      selectList: [],
      filterPeople: "",
      defaultPropsPerson: {
        children: "list",
        label: "name"
      }
    };
  },

  computed: {
    ...mapState({
      prjInfo: (state) => state.projectMg.prjObj,
      enterpriseId: (state) => state.enterprise.enterpriseId
    }),
    addChildPersonPlan() {
      return checkPermission(this.$allPerms.SHILDPERSONPLAN_ADD);
    },
    deleChildPersonPlan() {
      return checkPermission(this.$allPerms.SHILDPERSONPLAN_DELE);
    }
  },

  watch: {
    prjInfo: {
      deep: true,
      handler: function ({ prjId }, oldValue) {
        if (prjId) {
          this.initData();
        }
      }
    },
    searchValue(newValue, oldValue) {
      if (!newValue) {
        this.queryPersonList(this.currentData, this.currentNode);
      }
    },
    filterPeople(val) {
      this.$refs.personTree.filter(val);
    }
  },
  mounted() {
    this.initData();
  },
  methods: {
    back() {
      this.$router.push({ name: "personPlan" });
    },
    checkboxInit(row) {
      if (row.isPrjManageUser) {
        return 0;
      } else {
        return 1;
      } // 可勾选
    },
    async initData() {
      this.treeData = [];
      this.list = [];
      this.loadingTxt = "数据加载中...";
      this.loading = true;
      try {
        const prjId = storage.get("updatePrjcook");
        const result = await childPersonPlan.queryPrjChildTree(prjId);
        if (result.result === "0") {
          this.treeData = [];
          result.data.childId = result.data.prjId;
          result.data.childName = result.data.prjName;
          result.data.$show = 0;
          result.data.childList = result.data.childList.map((item) => {
            // item.childId = item.childId;
            // item.childName = item.childName;
            item.$show = 1;
            return item;
          });
          this.treeData.push(result.data);
          this.loading = false;
          this.$nextTick(() => {
            const clicks = document.querySelectorAll(".clickClass");
            if (clicks.length) {
              clicks[0].click();
            }
            this.$refs.tree.setCurrentKey(this.$refs.tree.store.root.data[0].childId);
            this.clickNodeTree(this.$refs.tree.store.root.data[0], this.$refs.tree.store.root.childNodes[0]);
          });
        }
      } catch (e) {
        this.loadingTxt = e.message || "查询" + this.$titles.child + "失败";
        this.$message.warning(e.message || "查询" + this.$titles.child + "失败");
      }
    },

    clickNodeTree(data, node) {
      this.queryPersonList(data, node);
      this.currentNode = node;
      this.currentData = data;
      if (data.childList) {
        this.currentDataShow = false;
      } else {
        this.currentDataShow = true;
      }
    },
    async queryPersonList(data, node) {
      console.log(data, "data");
      this.tableLoading = true;
      const childId = data.$show === 0 ? "" : encodeURIComponent(data.id);
      const { prjId } = this.prjInfo;
      try {
        const result = await childPersonPlan.queryPrjChildList(childId, prjId);
        if (result.result === "0") {
          this.list = result.data;
          this.tableLoading = false;
        }
      } catch (e) {
        this.tableLoading = false;
        this.$message.warning(e.message || "查询人员失败");
      }
    },

    async addPerson() {
      this.personAll = [];
      this.personChooseShow = true;
      this.addLoadingTxt = "数据加载中...";
      this.addLoading = true;
      try {
        const { enterpriseId } = this;
        const { prjId } = this.prjInfo;
        const result = await childPersonPlan.querySpecUserList(enterpriseId, prjId);
        result.data.forEach(ele => {
          ele.userIdRoleId = ele.userId;
          ele.list.forEach(item => {
            item.userIdRoleId = item.userId + item.roleId;
            item.nameBackups = item.name;
            item.name = item.name + "(" + item.roleName + ")";
          });
        });
        this.personAll = result.data;
        this.addLoading = false;
        this.resetChecked();
      } catch (e) {
        this.addLoadingTxt = e.message || "查询人员失败";
        this.$message.warning(e.message || "查询人员失败");
      }
    },
    async delPerson() {
      if (!this.selectArr[0]) return this.$message.warning("请选择人员");
      const newData = [];
      for (var g = 0; g < this.selectArr.length; g++) {
        const arr = {
          childId: this.selectArr[g].childId,
          userId: this.selectArr[g].userId,
          prjId: this.selectArr[g].prjId
        };
        newData.push(arr);
      }
      this.$confirm("确定删除吗?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          this.loadingTxt = "删除中...";
          this.loading = true;
          try {
            const result = await childPersonPlan.delPrjChild(newData);
            if (result.result === "0") {
              this.loading = false;
              this.$message({
                type: "success",
                message: "删除成功"
              });
              this.queryPrjlist();
            }
          } catch (e) {
            this.loading = false;
            this.$message.warning(e.message || "删除失败");
          }
        })
        .catch(() => {});
    },
    async queryPrjlist() {
      const { prjId } = this.prjInfo;
      const result = await requestprj.queryPrj("", this.enterpriseId);
      const projectInfo = result.data.find((item) => item.prjId === prjId);
      if (result.data.length) {
        if (!projectInfo) {
          this.$store.dispatch("myProjectsChange");
        } else {
          this.queryPersonList(this.currentData, this.currentNode);
        }
      } else {
        const data = {
          createTime: "",
          enterPrjTime: "",
          prjCode: "",
          prjId: "",
          prjName: ""
        };
        this.$store.dispatch("updatePrj", data);
        this.$router.push("/noproject");
      }
    },

    async confirmAddPerson() {
      this.addLoadingTxt = "人员策划中...";
      this.addLoading = true;
      const userListArr1 = this.selectList;
      const res = new Map();
      const userListArr2 = userListArr1.filter((a) => !res.has(a.userIdRoleId) && res.set(a.userIdRoleId, 1));
      for (var s = 0; s < userListArr2.length; s++) {
        for (var g = 0; g < userListArr1.length; g++) {
          if (userListArr2[s].userIdRoleId === userListArr1[g].userIdRoleId) {
            const arr = {
              specId: userListArr1[g].specId,
              specName: userListArr1[g].specName
            };
            userListArr2[s].specList.push(arr);
          }
        }
      }
      try {
        const result = await childPersonPlan.prjChildAdd(userListArr2);
        if (result.result === "0") {
          this.$message.success("人员策划成功");
          await this.queryPersonList(this.currentData, this.currentNode);
          this.personChooseShow = false;
          this.addLoading = false;
          this.resetChecked();
          this.$store.dispatch("unreadNum");
        }
      } catch (e) {
        this.addLoading = false;
        this.$message.warning(e.message || "人员策划失败");
      }
    },

    search() {
      const { searchValue: name } = this;
      if (!name) return this.$message.warning("请输入姓名、手机号、专业、" + this.$titles.child);
      this.loadingTxt = "搜索中...";
      this.loading = true;
      setTimeout(() => {
        this.list = this.list.filter((item) => this.filterKeyword(item, name));
        this.loading = false;
      }, 500);
    },

    filterKeyword(item, name) {
      const keyArr = ["userName", "phone", "specName", "childName"];
      let flag = false;
      while (keyArr[0] && !flag) {
        if (item[keyArr.shift()].includes(name)) flag = true;
      }
      return flag;
    },

    resetChecked() {
      this.selectList = [];
      this.filterPeople = "";
    },

    close() {
      this.personChooseShow = false;
      this.resetChecked();
    },

    selectChange(selection) {
      this.selectArr = selection;
    },
    findImagePath() {
      return require(`@/CommonDP/assets/wenjianjia.png`);
    },
    // 选择员工内的删除
    handleDelSelect(index) {
      this.selectList.splice(index, 1);
    },
    // 多选框选中
    clickNodeTreePeople(data, node) {
      if (!data.list) {
        const data1 = {};
        data1.childId = this.currentData.id;
        data1.childName = this.currentData.childName;
        data1.enterPrjTime = data.enterPrjTime;
        data1.enterpriseId = data.enterpriseId;
        data1.phone = data.linkPhone;
        data1.prjCode = data.prjCode;
        data1.prjId = data.prjId;
        data1.prjName = data.prjName;
        data1.userId = data.userId;
        data1.userName = data.nameBackups;
        data1.specId = node.parent.data.userId;
        data1.specName = node.parent.data.name;
        data1.selecName = data.name + "【" + node.parent.data.name + "】";
        data1.specList = [];
        data1.roleId = data.roleId;
        data1.roleName = data.roleName;
        data1.userIdRoleId = data.userIdRoleId;
        this.selectList.push(data1);
        // 去重
        const res = new Map();
        this.selectList = this.selectList.filter((a) => !res.has(a.selecName) && res.set(a.selecName, 1));
      } else {
        this.$message.warning("请选择人员");
      }
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    }
  }
};
</script>
<style lang="scss" scoped>
#childPersonPlan {
  width: 100%;
  height: 100%;
  .leftNav::-webkit-scrollbar {
    width: 6px;
    height: 10px;
  }
  .leftNav::-webkit-scrollbar-track {
    background: rgb(255, 255, 255);
    border-radius: 2px;
  }
  .leftNav::-webkit-scrollbar-thumb {
    background: #eee;
    border-radius: 10px;
  }
  .leftNav::-webkit-scrollbar-thumb:hover {
    background: #c4c6cc;
  }
  .left {
    position: absolute;
    width: 280px;
    height: 100%;
    background: #fff;
    border-radius: 4px;
    .leftNav {
      width: 280px;
      height: calc(100% - 59px);
      background-color: #fff;
      overflow-y: auto;
      padding: 0px 0 0 15px;
      box-sizing: border-box;
    }
    .textAll {
      width: 150px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      font-size: 14px;
    }
    .title {
      height: 56px;
      border-bottom: 1px solid #d0d7e6bf;
      padding-left: 16px;
      line-height: 56px;
      color: var(--key-color);
      font-size: 16px;
      font-weight: 600;
    }
  }
  .centerLine {
    width: 11px;
    height: 100%;
    background-color: #eff1f6;
    position: absolute;
    left: 280px;
  }
  .right {
    width: calc(100% - 300px);
    height: 100%;
    position: absolute;
    background: #fff;
    left: 293px;
    border-radius: 4px;
    .rightTop {
      border-top-left-radius: 4px;
      width: 100%;
      height: 65px;
      background-color: #fff;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 16px;
      box-sizing: border-box;
      border-bottom: 1px solid #eee;
      margin-bottom: 10px;
      .operations {
        display: flex;
        align-items: center;
        .btnBgColor {
          margin-right: 10px;
          margin-left: 0;
        }
      }
      .searchAndWarning {
        display: flex;
        align-items: center;
        .warning {
          display: flex;
          align-items: center;
          margin-right: 30px;
          span {
            color: red;
            white-space: nowrap;
            padding: 0 15px;
            background-color: #fba7c0;
            border-radius: 12px;
            margin-left: 2px;
          }
        }
        .search {
          display: flex;
          align-items: center;
          width: 300px;
        }
      }
    }
    .rightBottom {
      width: 100%;
      height: calc(100% - 80px);
      padding: 0 16px;
      box-sizing: border-box;
    }
  }
  /deep/ .el-dialog {
    .el-dialog__body {
      text-align: left;
      position: relative;
    }
  }
  .tabTransfer-dialog {
    border-radius: 5px;
    .el-dialog__body {
      padding-bottom: 20px !important;
      border-top: 1px solid #2e5bff1a;
      border-bottom: 1px solid #2e5bff1a;
      .personBox {
        .distribution {
          display: flex;
          height: 500px;

          .people,
          .selectPeople {
            flex: 1;
            border: 1px solid #eee;
            padding: 10px;
          }
          .search {
            display: flex;
            padding-bottom: 5px;
          }
          .tree {
            height: 450px;
            overflow: auto;
          }
          .people {
            border-right: 0;
          }

          .selectPeople {
            .box {
              height: 30px;
              line-height: 30px;
              span {
                font-size: 16px;
              }
            }
            ul {
              height: 455px;
              overflow: auto;
              border-top: 1px solid #eee;
              li {
                display: flex;
                align-items: center;
                justify-content: space-between;
                border-bottom: 1px solid #eee;
                padding: 15px;

                div {
                  font-size: 16px;
                  width: 18px;
                  height: 18px;
                  border-radius: 50%;
                  color: #626f81;
                  text-align: center;
                  line-height: 15px;
                  cursor: pointer;
                }
                span {
                  font-size: 14px;
                }
              }
            }
          }
        }
      }
    }
    .el-select {
      width: 100%;
    }
  }
}
</style>
<style lang="scss">
.eltooltipcehua {
  border: 1px solid #dde3f2 !important;
}
.eltooltipcehua .popper__arrow {
  border-bottom-color: #dde3f2 !important;
  border-top-color: #dde3f2 !important;
}
</style>
